"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wrapPageElement = exports.onClientEntry = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactHelmet = require("react-helmet");

var _interceptor = require("./utils/interceptor");

var wrapPageElement = function wrapPageElement(_ref) {
  var element = _ref.element;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactHelmet.Helmet, null, /*#__PURE__*/_react.default.createElement("script", {
    type: "module"
  }, "\n          const pagefind = await import('/pagefind/pagefind.js');\n          pagefind.init();\n          globalThis.pagefind = pagefind;\n        ")), element);
};

exports.wrapPageElement = wrapPageElement;

var onClientEntry = function onClientEntry() {
  if (typeof window !== 'undefined') {
    (0, _interceptor.interceptXMLHttpRequest)();
  }
};

exports.onClientEntry = onClientEntry;